class Breadcrumbs
  @$inject = ['$window', 'slashDB']
  constructor: ($window, slashdb) ->
    @breadcrumbs = []
    path = $window.location.pathname.replace /\.html+$/, ''
    path = path.replace /\/$/, ''
    params = new URLSearchParams($window.location.search)
    if not params.has('limit')
      defaultLimit = parseInt(slashdb.settings.html_limit) or 29
      params.set('limit', defaultLimit)


    queriesPath = localStorage.getItem 'breadcrumbsQueriesPath'
    if not queriesPath
      queriesPath = '/query'

    if path == '/querydef' and not $window.document.querySelector('.error_message')
      localStorage.setItem 'breadcrumbsQueriesPath', '/querydef'

    if path == '/query'
      localStorage.setItem 'breadcrumbsQueriesPath', '/query'

    while path
      segments = path.split('/')
      bName = decodeURI segments.pop()
      bPath = path

      bName = switch bName
        when 'dbdef' then 'Database Definitions'
        when 'userdef' then 'User Definitions'
        when 'querydef' then 'Query Definitions'
        when 'query' then 'Queries'
        #when 'querystudio' then 'Query Studio'
        when 'license' then 'License'
        else bName

      # On segment 'querystudio' we want to redirect to queries list instead of empty query studio form
      if bName == 'querystudio'
        bName = 'Queries'
        bPath = queriesPath

      if segments.length < 3
        search = $window.location.search
      else
        search = '?' + params.toString()

      bPath = bPath + search

      @breadcrumbs.push {name: bName, path: bPath}
      path = segments.join('/')

    @breadcrumbs.push {name: 'NICE Data Explorer', path: '/'}
    @breadcrumbs = @breadcrumbs.reverse()

    return null

angular.module 'sdbgui'
.component 'breadcrumbs', {
  templateUrl: '/static/components/sdbgui-breadcrumbs/breadcrumbs.html'
  controller: Breadcrumbs
}
